import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../styles/lib/utils';
import { GridContext } from '../Grid';

const gridHeadCellVariants = cva('flex items-center border-b border-grey-30 px-1 py-1 flex-shrink-0', {
  variants: {
    spacing: {
      cozy: 'h-8',
      comfy: 'h-10',
      roomy: 'h-13',
    },
  },
  defaultVariants: {
    spacing: 'cozy',
  },
});

type GridHeadCellProps = React.ComponentProps<'th'> &
  VariantProps<typeof gridHeadCellVariants> & {
    asChild?: boolean;
  };

function GridHeadCell({ className, spacing, asChild = false, children, ...props }: GridHeadCellProps) {
  const Comp = asChild ? Slot : 'th';
  const gridContext = React.useContext(GridContext);
  const effectiveSpacing = spacing || gridContext.spacing || 'cozy';

  return (
    <Comp
      role="columnheader"
      data-slot="grid-head-cell"
      data-spacing={effectiveSpacing}
      className={cn(gridHeadCellVariants({ spacing: effectiveSpacing, className }))}
      {...props}
    >
      {children}
    </Comp>
  );
}

export { GridHeadCell, type GridHeadCellProps };
